import React, { useEffect } from 'react';

import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import type { PMPlugin } from '@atlaskit/editor-common/types';
import { WithPluginState } from '@atlaskit/editor-common/with-plugin-state';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

import { createPlugin } from './pm-plugins/ai-definitions/plugin';
import { aiDefinitionsPluginKey } from './pm-plugins/ai-definitions/plugin-key';
import { type AIDefinitionsPlugin } from './types';

export const aiDefinitionsPlugin: AIDefinitionsPlugin = ({ api, config }) => {
	return {
		name: 'aiDefinitions',

		usePluginHook({ editorView }) {
			const { editorViewModeState } = useSharedPluginState(api, ['editorViewMode']);
			const livePageMode = editorViewModeState?.mode;

			useEffect(() => {
				//
			}, [livePageMode]);
		},

		pmPlugins() {
			const pmPlugins: PMPlugin[] = [];

			if (editorExperiment('platform_editor_live_pages_ai_definitions', 'test')) {
				pmPlugins.push({
					name: 'aiDefinitions',
					plugin: (params) => createPlugin(params, api, config),
				});
			}

			return pmPlugins;
		},

		contentComponent: () => {
			const livePageMode = api?.editorViewMode.sharedState.currentState()?.mode;
			if (
				config.isLivePage &&
				livePageMode === 'view' &&
				editorExperiment('platform_editor_live_pages_ai_definitions', 'test')
			) {
				const { ReadingAidsPopup } = config;
				return (
					<WithPluginState<{
						aiDefinitionsPluginState: typeof aiDefinitionsPluginKey;
					}>
						plugins={{ aiDefinitionsPluginState: aiDefinitionsPluginKey }}
						render={({ aiDefinitionsPluginState }) => {
							if (
								aiDefinitionsPluginState &&
								aiDefinitionsPluginState.isReadingAidsPopupOpen &&
								aiDefinitionsPluginState.readingAidsPopupProps &&
								ReadingAidsPopup
							) {
								return <ReadingAidsPopup {...aiDefinitionsPluginState.readingAidsPopupProps} />;
							}
							return null;
						}}
					></WithPluginState>
				);
			} else {
				return null;
			}
		},
	};
};
